import { IPagination } from 'app/types/common';

export interface IMatchPaymentsState {
  readonly matchPaymentsById?: any;
  readonly matchPaymentIds?: string[];
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly showAddMatchPayment?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationMatchPaymentIds?: string[];
  readonly currentMatchPaymentId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IMatchPaymentsSelector extends IMatchPaymentsState {
  readonly currentMatchPayment?: any;
  readonly currentFormMatchPayment?: any;
  readonly getMatchPaymentsFilteredByTagInSelectFormat?: any;
  readonly matchPaymentsByIdInSelectFormat?: any;
}

export enum MatchPaymentsActionTypes {
  GET_ALL_MATCH_PAYMENTS_REQUESTED = 'redux-app/payment-collections/GET_ALL_MATCH_PAYMENTS_REQUESTED',
  GET_ALL_MATCH_PAYMENTS_PENDING = 'redux-app/payment-collections/GET_ALL_MATCH_PAYMENTS_PENDING',
  GET_ALL_MATCH_PAYMENTS_SUCCESS = 'redux-app/payment-collections/GET_ALL_MATCH_PAYMENTS_SUCCESS',
  GET_ALL_MATCH_PAYMENTS_FAIL = 'redux-app/payment-collections/GET_ALL_MATCH_PAYMENTS_FAIL',
  GET_MATCH_PAYMENT_REQUESTED = 'redux-app/payment-collections/GET_MATCH_PAYMENT_REQUESTED',
  GET_MATCH_PAYMENT_PENDING = 'redux-app/payment-collections/GET_MATCH_PAYMENT_PENDING',
  GET_MATCH_PAYMENT_SUCCESS = 'redux-app/payment-collections/GET_MATCH_PAYMENT_SUCCESS',
  GET_MATCH_PAYMENT_FAIL = 'redux-app/payment-collections/GET_MATCH_PAYMENT_FAIL',
  UPDATE_MATCH_PAYMENT_REQUESTED = 'redux-app/payment-collections/UPDATE_MATCH_PAYMENT_REQUESTED',
  UPDATE_MATCH_PAYMENT_PENDING = 'redux-app/payment-collections/UPDATE_MATCH_PAYMENT_PENDING',
  UPDATE_MATCH_PAYMENT_SUCCESS = 'redux-app/payment-collections/UPDATE_MATCH_PAYMENT_SUCCESS',
  UPDATE_MATCH_PAYMENT_FAIL = 'redux-app/payment-collections/UPDATE_MATCH_PAYMENT_FAIL',
  CREATE_MATCH_PAYMENT_REQUESTED = 'redux-app/payment-collections/CREATE_MATCH_PAYMENT_REQUESTED',
  CREATE_MATCH_PAYMENT_PENDING = 'redux-app/payment-collections/CREATE_MATCH_PAYMENT_PENDING',
  CREATE_MATCH_PAYMENT_SUCCESS = 'redux-app/payment-collections/CREATE_MATCH_PAYMENT_SUCCESS',
  CREATE_MATCH_PAYMENT_FAIL = 'redux-app/payment-collections/CREATE_MATCH_PAYMENT_FAIL',
  DELETE_MATCH_PAYMENT_REQUESTED = 'redux-app/payment-collections/DELETE_MATCH_PAYMENT_REQUESTED',
  DELETE_MATCH_PAYMENT_PENDING = 'redux-app/payment-collections/DELETE_MATCH_PAYMENT_PENDING',
  DELETE_MATCH_PAYMENT_SUCCESS = 'redux-app/payment-collections/DELETE_MATCH_PAYMENT_SUCCESS',
  DELETE_MATCH_PAYMENT_FAIL = 'redux-app/payment-collections/DELETE_MATCH_PAYMENT_FAIL',
  SELECT_MATCH_PAYMENT_REQUESTED = 'redux-app/payment-collections/SELECT_MATCH_PAYMENT_REQUESTED',
  CLEAR_MATCH_PAYMENTS = 'redux-app/payment-collections/CLEAR_MATCH_PAYMENTS',
}

export default null;
